import styled from 'styled-components';
import { default as C } from '@assets/themes/colors';

export const Root = styled.div`
  background-color: ${C.DARK_BLUE};
`

export const MenuContainerInit = styled.div`
  overflow: hidden;
  height: 100vh;
  transition: all 0.2s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
`

export const MenuTitle = styled.div`
  height: 63px;
  font-family: 'Roboto';
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.DARK_WHITE};
  white-space: nowrap;
  overflow: hidden;
  border-bottom: 1px solid ${C.BLUE};
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const OptionsContainer = styled.div`
`

export const Option = styled.div`
  height: 50px;
  padding: 0px 0px 0px 50px;
  font-family: 'Roboto';
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  cursor: pointer;
  color: ${C.WHITE};
  white-space: nowrap;
  overflow: hidden;
  display: flex;
  align-items: center;
  &:hover {
    background-color: #28364f;
  }
`